// src/components/Cobertura.js

import React from 'react';
import { cobertura } from '../data/hospitalData';
import '../styles/Cobertura.css';

const Cobertura = () => {
  return (
    <div className="coverage-page-wrapper">
      <div className="coverage-container">
        <header className="coverage-header">
          <h1>Obras Sociales y Prepagas</h1>
          <p>Trabajamos con una amplia red de obras sociales y prepagas para brindarte el mejor servicio. Consulta el listado completo a continuación.</p>
        </header>

        <main className="coverage-grid">
          {cobertura.map((obraSocial) => (
            <div key={obraSocial.nombre} className="coverage-card">
              <img 
                src={obraSocial.logoUrl} 
                alt={`Logo de ${obraSocial.nombre}`} 
                className="coverage-logo"
              />
            </div>
          ))}
        </main>
      </div>
    </div>
  );
};

export default Cobertura;